import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import CollectionSelect from 'components/application/CollectionSelect';

export default function SelectCompanyRoles({
  assignableRolesCollection,
  currentPersonnel,
  fieldError,
  isCreatable,
  onAssignableRoleAdd,
  onChange,
  onNewCompanyRoleAdd,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.SelectCompanyRoles',
  });

  const { t: i18nTRoles } = useTranslation('common', {
    keyPrefix: 'roles',
  });

  const companyRoleOption = (companyRole) => ({
    value: companyRole.id,
    label: companyRole.attributes.position,
  });

  const currentPersonnelCompanyRoles = assignableRolesCollection.filter(
    (role) => currentPersonnel.companyRoleIds.includes(role.id),
  );

  const companyRoleValues = currentPersonnelCompanyRoles.map((role) =>
    role ? companyRoleOption(role) : '',
  );

  const companyRoleOptions = function () {
    return assignableRolesCollection ?
        assignableRolesCollection
          .map((role) => companyRoleOption(role))
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];
  };

  const generateNewCompanyRole = (inputValue) => {
    const companyRoleUuid = uuidv4();
    onNewCompanyRoleAdd({ id: companyRoleUuid, position: inputValue });
    const newRole = {
      id: companyRoleUuid,
      type: 'companyRole',
      attributes: { position: inputValue },
    };
    onAssignableRoleAdd(newRole);
    return companyRoleUuid;
  };

  const handleCreateOption = (inputValue) => {
    const companyRoleUuid = generateNewCompanyRole(inputValue);
    const newCompanyRoleValues = companyRoleValues.concat({
      value: companyRoleUuid,
      label: inputValue,
    });
    onChange(newCompanyRoleValues);
  };

  return (
    <CollectionSelect
      externalProps={
        isCreatable ?
          {
            onCreateOption: handleCreateOption,
            controlShouldRenderValue: false,
            styles: {
              valueContainer: (provided, _state) => ({
                ...provided,
                // There are paddings added to the usual valueContainer when it is multi select. This stops them taking effect on the placeholder in this valueContainer.
                paddingLeft: '10px !important',
              }),
            },
          }
        : { additionalNoOptionsMessage: i18nT('additionalNoOptionsMessage') }
      }
      isCreatable={isCreatable}
      isMulti={true}
      isSearchable={true}
      modifiers={['expandable', fieldError ? ' field__invalid' : '']}
      name='companyRoleIds'
      onChange={onChange}
      options={companyRoleOptions()}
      placeholder={i18nTRoles('searchRoles')}
      value={companyRoleValues}
    />
  );
}

SelectCompanyRoles.propTypes = {
  currentPersonnel: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
